import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import './Hero.css';

const HeroSection = () => {
  const scrollToWaitlist = (e) => {
    e.preventDefault();
    const waitlistSection = document.getElementById('waitlist-section');
    if (waitlistSection) {
      const waitlistPosition = waitlistSection.getBoundingClientRect().top + window.pageYOffset;
      const offset = 30; // Adjust this value to control the space above the heading
      window.scrollTo({
        top: waitlistPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  const scrollToFeatures = (e) => {
    e.preventDefault();
    const featuresSection = document.getElementById('value-prop');
    if (featuresSection) {
      const featuresPosition = featuresSection.getBoundingClientRect().top + window.pageYOffset;
      const offset = 80; // Adjust for navbar height
      window.scrollTo({
        top: featuresPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">
          The First AI Project Copilot for Neurodivergent Thinkers.
        </h1>
        <p className="hero-subtitle">
        Turn overwhelm into clarity. Attenxion helps neurodivergent individuals and teams manage research, coursework, and complex projects by effortlessly breaking them down into clear, actionable steps and guiding users smoothly past the finish line.
        </p>
        <a href="#waitlist-section" className="hero-button" onClick={scrollToWaitlist}>
          Get Early Access 
        </a>
      </div>
      <div className="hero-image">
        <img
          src="/cropped.png"
          alt="Woman using laptop with robot assistant"
        />
      </div>
      <div className="scroll-arrow" onClick={scrollToFeatures}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
